"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatePositionFundingPNL = exports.calculatePositionPNL = exports.calculateBaseAssetValue = void 0;
const types_1 = require("../types");
const numericConstants_1 = require("../constants/numericConstants");
const bn_js_1 = __importDefault(require("bn.js"));
const amm_1 = require("./amm");
const numericConstants_2 = require("../constants/numericConstants");
/**
 * calculateBaseAssetValue
 * = market value of closing entire position
 * @param market
 * @param userPosition
 * @returns Base Asset Value. : Precision QUOTE_PRECISION
 */
function calculateBaseAssetValue(market, userPosition) {
    if (userPosition.baseAssetAmount.eq(numericConstants_1.ZERO)) {
        return numericConstants_1.ZERO;
    }
    const directionToClose = userPosition.baseAssetAmount.gt(numericConstants_1.ZERO)
        ? types_1.PositionDirection.SHORT
        : types_1.PositionDirection.LONG;
    const [newQuoteAssetReserve, _] = amm_1.calculateAmmReservesAfterSwap(market.amm, 'base', userPosition.baseAssetAmount.abs(), amm_1.getSwapDirection('base', directionToClose));
    switch (directionToClose) {
        case types_1.PositionDirection.SHORT:
            return market.amm.quoteAssetReserve
                .sub(newQuoteAssetReserve)
                .mul(market.amm.pegMultiplier)
                .div(numericConstants_1.PEG_PRECISION)
                .div(numericConstants_1.AMM_TO_QUOTE_PRECISION_RATIO);
        case types_1.PositionDirection.LONG:
            return newQuoteAssetReserve
                .sub(market.amm.quoteAssetReserve)
                .mul(market.amm.pegMultiplier)
                .div(numericConstants_1.PEG_PRECISION)
                .div(numericConstants_1.AMM_TO_QUOTE_PRECISION_RATIO);
    }
}
exports.calculateBaseAssetValue = calculateBaseAssetValue;
/**
 * calculatePositionPNL
 * = BaseAssetAmount * (Avg Exit Price - Avg Entry Price)
 * @param market
 * @param marketPosition
 * @param withFunding (adds unrealized funding payment pnl to result)
 * @returns BaseAssetAmount : Precision QUOTE_PRECISION
 */
function calculatePositionPNL(market, marketPosition, withFunding = false) {
    if (marketPosition.baseAssetAmount.eq(numericConstants_1.ZERO)) {
        return numericConstants_1.ZERO;
    }
    const directionToClose = marketPosition.baseAssetAmount.gt(numericConstants_1.ZERO)
        ? types_1.PositionDirection.SHORT
        : types_1.PositionDirection.LONG;
    const baseAssetValue = calculateBaseAssetValue(market, marketPosition);
    let pnlAssetAmount;
    switch (directionToClose) {
        case types_1.PositionDirection.SHORT:
            pnlAssetAmount = baseAssetValue.sub(marketPosition.quoteAssetAmount);
            break;
        case types_1.PositionDirection.LONG:
            pnlAssetAmount = marketPosition.quoteAssetAmount.sub(baseAssetValue);
            break;
    }
    if (withFunding) {
        const fundingRatePnL = calculatePositionFundingPNL(market, marketPosition).div(numericConstants_2.PRICE_TO_QUOTE_PRECISION);
        pnlAssetAmount = pnlAssetAmount.add(fundingRatePnL);
    }
    return pnlAssetAmount;
}
exports.calculatePositionPNL = calculatePositionPNL;
/**
 *
 * @param market
 * @param marketPosition
 * @returns // TODO-PRECISION
 */
function calculatePositionFundingPNL(market, marketPosition) {
    if (marketPosition.baseAssetAmount.eq(numericConstants_1.ZERO)) {
        return numericConstants_1.ZERO;
    }
    let ammCumulativeFundingRate;
    if (marketPosition.baseAssetAmount.gt(numericConstants_1.ZERO)) {
        ammCumulativeFundingRate = market.amm.cumulativeFundingRateLong;
    }
    else {
        ammCumulativeFundingRate = market.amm.cumulativeFundingRateShort;
    }
    const perPositionFundingRate = ammCumulativeFundingRate
        .sub(marketPosition.lastCumulativeFundingRate)
        .mul(marketPosition.baseAssetAmount)
        .div(numericConstants_2.AMM_RESERVE_PRECISION)
        .div(numericConstants_2.FUNDING_PAYMENT_PRECISION)
        .mul(new bn_js_1.default(-1));
    return perPositionFundingRate;
}
exports.calculatePositionFundingPNL = calculatePositionFundingPNL;
